'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.Link3Styles = exports.Link2Styles = exports.Link1Styles = undefined;

var _templateObject = _taggedTemplateLiteral(['\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n    letter-spacing: ', ';\n\tcolor: ', ';\n'], ['\n\tfont-family: ', ';\n\tfont-weight: ', ';\n\tfont-size: ', ';\n\tline-height: ', ';\n    letter-spacing: ', ';\n\tcolor: ', ';\n']);

var _styledComponents = require('styled-components');

var _colors = require('../../constants/colors');

var _text = require('../../constants/text');

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Link1Styles = exports.Link1Styles = (0, _styledComponents.css)(_templateObject, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightMedium, _text.TextSizes.P1FontSize, _text.TextSizes.P1LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref) {
	var inverse = _ref.inverse,
	    disabled = _ref.disabled;
	return disabled ? _colors.Colors.StrokeVeryDark : inverse ? _colors.Colors.LightMode : _colors.Colors.Secondary;
});

var Link2Styles = exports.Link2Styles = (0, _styledComponents.css)(_templateObject, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightMedium, _text.TextSizes.P2FontSize, _text.TextSizes.P2LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref2) {
	var inverse = _ref2.inverse,
	    disabled = _ref2.disabled;
	return disabled ? _colors.Colors.StrokeVeryDark : inverse ? _colors.Colors.LightMode : _colors.Colors.Secondary;
});

var Link3Styles = exports.Link3Styles = (0, _styledComponents.css)(_templateObject, _text.TextSizes.ParagraphFontFamily, _text.TextSizes.WeightMedium, _text.TextSizes.P3FontSize, _text.TextSizes.P3LineHeight, _text.TextSizes.ParagraphLetterSpacing, function (_ref3) {
	var inverse = _ref3.inverse,
	    disabled = _ref3.disabled;
	return disabled ? _colors.Colors.StrokeVeryDark : inverse ? _colors.Colors.LightMode : _colors.Colors.Secondary;
});